<template>
  <div class="vue-outer-wrap">
    <div v-if="user" class="edit-utility-type-container">
      <span
      v-if="errorMessage"
      v-bind:class="{fade: fadeErrorMessage}"
      class="error-message">{{errorMessage}}</span>
      <div class="header">Edit Utility Type<span v-if="selectedUtilityType">: <span class="utility-type-name">{{selectedUtilityType.name}}</span></span></div>
      <div class="controls-container utility-type-select">
        <div class="selected-utility-type-container" v-if="selectedUtilityTypeForEdit">
          <!-- name -->
          <div class="controls-container selected-utility-type">
            <div class="control utility-type-name">
              <label for="utilityType">Name:</label>
              <input v-model="selectedUtilityTypeForEdit.name" placeholder="Utility type name" type="text" class="name" v-bind:disabled="updatingUtilityType">
            </div>
          </div>
          <!-- code -->
          <div class="controls-container selected-utility-type">
            <div class="control utility-type-code">
              <label for="utility-type">Code:</label>
              <input v-model="selectedUtilityTypeForEdit.code" placeholder="Utility type code" type="text" class="code" v-bind:disabled="updatingUtilityType">
            </div>
          </div>
          <!-- description -->
          <div class="controls-container selected-utility-type">
            <div class="control utility-type-description">
              <label for="utility-type">Description:</label>
              <input v-model="selectedUtilityTypeForEdit.description" placeholder="Utility type description" type="text" class="description" v-bind:disabled="updatingUtilityType">
            </div>
          </div>
          <div class="buttons-container">
            <b-spinner v-if="updatingUtilityType" class="ajax-spinner"></b-spinner>
            <b-button
            class="btn cancel"
            v-on:click="hideForm()"
            v-bind:disabled="updatingUtilityType"
            v-if="!updatingUtilityType && !deleteMode">Cancel</b-button>
            <b-button
            class="btn submit"
            v-on:click="submitUtilityType()"
            v-if="!updatingUtilityType && !deleteMode"
            v-bind:disabled="updatingUtilityType">Update Utility Type</b-button>
            <span
            class="delete-button-container"
            v-if="!updatingUtilityType">
            <delete-button-with-confirm
            :deleteClicked="onDeleteButtonClicked"
            :cancelClicked="onDeleteCancelButtonClicked"
            :deleteConfirmClicked="onDeleteConfirmButtonClicked"
            :buttonText="'Delete ' + selectedUtilityTypeForEdit.name"
            :confirmText="'Confirm delete: ' + selectedUtilityTypeForEdit.name"></delete-button-with-confirm>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import API from "@/services/api";
import DeleteButtonWithConfirm from "../../../../../shared/buttons/delete-button-with-confirm/DeleteButtonWithConfirm";

export default {
  name: 'EditUtilityType',
  components: {
    DeleteButtonWithConfirm
  },
  props: {
    hide: Function,
    utilityTypes: Array,
    selectedUtilityType: Object,
    utilityTypeUpdateSuccess: Function,
    onUtilityTypeRemoveSuccess: Function
  },
  data() {
    return {
      user: undefined,
      deleteMode: false,
      errorMessage: false,
      fadeErrorMessage: false,
      updatingUtilityType: false,
      placeholderUtilityTypeId: 999,
      placeholderUtilityTypeSet: false,
      selectedUtilityTypeForEdit: undefined,
    }
  },
  async created() {
    this.selectedUtilityTypeForEdit = JSON.parse(JSON.stringify(this.selectedUtilityType));
  },
  beforeCreate() {
    Auth.currentAuthenticatedUser()
      .then(user => {
          this.user = user;
      })
      .catch(() => console.log('not signed in...'))
  },
  watch: {
    selectedUtilityType: function (selectedUtilityType) {
      this.selectedUtilityTypeForEdit = JSON.parse(JSON.stringify(selectedUtilityType));
    }
  },
  methods: {
    onUtilityTypeUpdated () {
      this.GetUtilityTypes();
    },
    hideForm(){
      this.hide()
    },
    onDeleteButtonClicked() {
      this.deleteMode = true;
    },
    onDeleteCancelButtonClicked() {
      this.deleteMode = false;
    },
    onDeleteConfirmButtonClicked() {
      this.deleteUtilityType();
    },
    deleteUtilityType(){
      this.updatingUtilityType = true;
      try {
        API.RemoveUtilityType(this.selectedUtilityTypeForEdit.utilityTypeId).then(() => {
          this.onUtilityTypeRemoveSuccess(this.selectedUtilityTypeForEdit);
        }, err => {
          console.error('deleteUtilityType - ERROR');
          console.dir(err);
          this.updatingUtilityType = false;
        })
      } catch (err) {
          this.updatingUtilityType = false;
          console.error('deleteUtilityType - catch  - ERROR');
          console.dir(err);
      }
    },
    submitUtilityType(){
      this.updatingUtilityType = true;
      const utilityType = this.selectedUtilityTypeForEdit;
      const postData = {
        utilityTypeId: utilityType.utilityTypeId,
        name: utilityType.name,
        code: utilityType.code,
        description: utilityType.description
      };
      try {
        API.UpdateUtilityType(postData).then((data) => {
          this.updatingUtilityType = false;
          this.utilityTypeUpdateSuccess(data);
          this.hide();
          this.placeholderUtilityTypeSet = false;
          this.utilityTypesForDropdown = undefined;
        }, err => {
          console.error('UpdateUtilityType - ERROR');
          console.dir(err);
          this.updatingUtilityType = false;
          if (err
          && err.response
          && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
              this.errorMessage = `Error updating ${this.selectedUtilityTypeForEdit.name}`;
          }
          setTimeout(() => {this.fadeErrorMessage = true}, 3000);
          setTimeout(() => {
            this.errorMessage = '';
            this.fadeErrorMessage = false;
          }, 6000);
        })
      } catch (err) {
          this.updatingUtilityType = false;
          console.error('POST ERROR!');
          console.dir(err);
      }
    },
    resetSelectedUtilityType(){
      this.selectedUtilityTypeForEdit = undefined;
      // Emit event to parent to reset the selectedUtilityType prop
      this.$emit('reset-selected-utility-type');
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../../../assets/css/partials/_variables.scss";

  .edit-utility-type-container{
    position: relative;
    width: 100%;
    margin: 20px auto;

    input[type="text"] {
      width: 100%;
    }

    .utility-type-name{
      color: #333;
    }

    .success-message{
      position: absolute;
      top: 0;
      right: 23px;
      font-weight: bold;
      color: #196319;
      -webkit-transition: all 2s ease-in-out;
      -moz-transition: all 2s ease-in-out;
      -o-transition: all 2s ease-in-out;
      transition: all 2s ease-in-out;

      &.fade {
          opacity: 0;
      }
    }

    .error-message{
      position: absolute;
      top: 0;
      right: 23px;
      font-size: 18px;
      font-weight: bold;
      color: #800000;
      -webkit-transition: all 2s ease-in-out;
      -moz-transition: all 2s ease-in-out;
      -o-transition: all 2s ease-in-out;
      transition: all 2s ease-in-out;

      &.fade {
          opacity: 0;
      }
    }

    .header{
      margin-bottom: 10px;
      font-weight: $bold;
      color: $black;
    }

    .controls-container {

      .control{
        width: 80%;
        margin-bottom: 20px;
        padding: 10px;
        background-color: $modalGrey;

        input[type="text"] {
          width: 100%;
          height: 40px;
          padding-left: 10px;
          border: none;
        }
      }

      &.utility-type-select{
        select{
          margin-left: 5px; 
        } 
      }

      &.selected-utility-type{
        margin-top: 10px;
      }

      label {
        margin-right: 10px;
        font-weight: bold;
      }
    }

    .buttons-container{
      padding: 10px;

      .ajax-spinner{
        position: relative;
        top: 6px;
        right:15px;
        color: #fbd850;
      }

      .btn{
        margin-right: 10px;
      }
    }
  }
</style>
